module.exports = `${require.publicPath}robot-avatar.5ba8b8b7.png`;